/**
 * Component Registry for The Blakely
 * 
 * Inherits from @vibesites-axia-residential-arc-living/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-axia-residential-arc-living/theme-preferred/registry';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PreferredEmployerProgram } from './components/PreferredEmployerProgram';
import { SitemapContent } from './components/SitemapContent';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Header — includes Preferred Employer Program in the hamburger nav (the
  // parent Header only reads base theme-preferred pages.json, which omits it).
  Header,
  // Hero — property-specific fork that pins the background video to the
  // Shoootin-hosted MP4 for The Blakely (custom_property_featured_video wins
  // if ever set on the property).
  Hero,
  // Preferred Employer Program — Blakely-specific employer roster and
  // waived application + admin fee benefits.
  PreferredEmployerProgram,
  // SitemapContent — lists Preferred Employer Program alongside other pages.
  SitemapContent,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
